import { FETCH_START, FETCH_END, DISTRIBUTOR_CONTRACT_DATA } from '../../actions/DistributorChargeback/ActionTypes';

const initialState = {
  loading: false,
  contractData: {},
};

const DistributorChargebackReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISTRIBUTOR_CONTRACT_DATA:
      return { ...state, contractData: action.data };
    case FETCH_START:
      return { ...state, loading: true };
    case FETCH_END:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default DistributorChargebackReducer;
